<div class="modal-header">
  <h6 class="modal-header-title">Protector package help</h6>
</div>

<div class="modal-body">
  <div class="non-scrollable">
    <div class="bolt-row">
      <span class="bolt-col-12 subsection-header"
        >Choose <i>Protector</i> tab to review details on each coverage</span
        >
      </div>
      <nwx-carousel
        #carousel
        class="bolt-col-12 wide-content gap-0 gap-lg-3"
        [items]="items"
        >
        @for (item of items; track item.name) {
          <div>
            <div
              class="persona-name"
              (click)="onChoosePersona(item.name, $event)"
              [ngClass]="{ selected: personaNameSelected === item.name }"
              >
              {{ item.label }}
            </div>
          </div>
        }
      </nwx-carousel>

      <div class="bolt-row">
        <div class="bolt-col-12 persona-help pb-2">
          {{ getPersonaHelpContent() }}
        </div>
      </div>
    </div>

    <div class="scrollable">
      @for (item of getHelpContentTypes(); track item.type) {
        <div class="bolt-row help">
          <div class="bolt-col-6 d-flex justify-content-start my-3 type-title">
            {{ item.type }}
          </div>
          <div class="bolt-col-6 d-flex justify-content-end my-3">
            <img
              class="types-icon"
              [src]="'/assets/images/icons/' + item.icon"
              role="presentation"
              />
            </div>
            @for (content of getHelpContent(item.type); track content.name) {
              <div
                class="bolt-col-12 help-content my-2"
                >
                <div class="icon-group">
                  @if (content.icon.includes('.svg')) {
                    <img
                      class="icon"
                      style="width: 24px"
                      [src]="'/assets/images/icons/' + content.icon"
                      role="presentation"
                      />
                    } @else {
                      <bolt-icon [name]="content.icon" color="vibrantBlue"></bolt-icon>
                    }
                    <div class="help-name-text ms-2">
                      <span class="help-name">{{ content.name }}</span>
                      <div [innerHTML]="content.helpText" class="help-text"></div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
      <div class="footer">
        <bolt-button type="solid" (click)="closeModal()">Close </bolt-button>
      </div>
